import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService {

  host: string;
  oauthUrl: string;
  clien_id: string;
  secret_id: string;
  authbackUrl: string;

  constructor() {

    this.host = 'https://offers.peoplefone.ch'; 
    this.oauthUrl = 'https://auth.peoplefone.com';
    this.clien_id = '1';
    this.authbackUrl = 'https://offers.peoplefone.ch/authback';

    if(window.location.host.match('localhost')) {
      this.clien_id = '3';
      this.oauthUrl = 'http://localhost:8071';
      this.host = 'http://localhost:8099';
      this.authbackUrl = 'http://localhost:8099/authback';
    }
  }

  configure() {
  }


}



// WEBPACK FOOTER //
// ./src/app/config.service.ts